import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { isLoaded, useFirestoreConnect } from 'react-redux-firebase'

import { useAuth } from './use-auth'
import { useOrgFeatureFlags } from './use-feature-flags'

export const ORG_SHARE_OPTIONS = {
    public: 'public',
    anyoneInOrg: 'anyoneInOrg',
    private: 'private'
} as const

export const COMMENTS_STATUS_OPTIONS = {
    on: 'on',
    anyoneInOrg: 'anyoneInOrg',
    off: 'off'
} as const

export const useOrganization = (propsOrgId?: string) => {
    const { orgId: authOrgId } = useAuth()

    const orgId = propsOrgId || authOrgId
    const { showDefaultCoverColors } = useOrgFeatureFlags()

    useFirestoreConnect({
        collection: 'organizations',
        doc: orgId
    })

    const organization = useSelector(state => state.firestore.data?.organizations)

    const isLoading = !isLoaded(organization)

    const {
        name = '',
        logo = '',
        domains = [],
        useDefaultCoverColors = false,
        id = '',
        ownerAgency = '',
        accountOwners = '',
        defaultSpaces = [],
        extLogo = '',
        extColor = '#fff',
        extSettings = {},
        defaultSharingSettings = 'private',
        comments = 'on'
    } = organization?.[orgId] || {}

    return useMemo(
        () =>
            ({
                name,
                logo,
                domains,
                id,
                ownerAgency,
                accountOwners,
                defaultSpaces,
                extLogo,
                useDefaultCoverColors: showDefaultCoverColors ? useDefaultCoverColors : false,
                extColor,
                extSettings,
                isLoading,
                defaultSharingSettings,
                comments
            } as const),
        [
            accountOwners,
            extSettings,
            domains,
            useDefaultCoverColors,
            isLoading,
            id,
            logo,
            name,
            ownerAgency,
            defaultSpaces,
            extLogo,
            showDefaultCoverColors,
            extColor,
            defaultSharingSettings,
            comments
        ]
    )
}
